import Validator from "./Validator";

export default class JsonEntitiesEntityDataAnswerRequiredValidator extends Validator {
  constructor() {
    super();
    this.validationRules = {
      type: 'boolean',
      empty: false,
      mandatory: false
    };
  }
}
